<template>
    <div>
      <el-input-number
        style="width: 109px"
        controls-position="right"
        :precision="precision"
        :step="step"
        :min="min"
        :max="max"
        :value="minInput || undefined"
        @change="changeMin"
        placeholder="最小值"
      ></el-input-number>
      至
      <el-input-number
        style="width: 109px"
        controls-position="right"
        :precision="precision"
        :step="step"
        :min="min"
        :max="max"
        :value="maxInput || undefined"
        @change="changeMax"
        placeholder="最大值"
      ></el-input-number>
    </div>
  </template>
  
  <script>
  export default {
    name: "NumberRangeInput",
    props: {
      precision: {
        type: Number,
        default: 0,
      },
      step: {
        type: Number,
        default: 1,
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 2147483647,
      },
      minVal: {
        type: [String, Number],
      },
      maxVal: {
        type: [String, Number],
      },
    },
    watch: {
      minVal: {
        handler(val) {
          this.minInput = this.minVal;
        },
        immediate: true,
      },
      maxVal: {
        handler(val) {
          this.maxInput = this.maxVal;
        },
        immediate: true,
      },
    },
    data() {
      return {
        minInput: null,
        maxInput: null,
      };
    },
    methods: {
      changeMin(val) {
        this.minInput = val;
        if (this.minInput && this.maxInput && this.minInput > this.maxInput) {
          this.$message({
            message: "输入的最小值不得大于最大值！",
            type: "error",
          });
          return;
        }
        this.$emit("update:minVal", this.minInput);
        this.$emit("change");
      },
      changeMax(val) {
        this.maxInput = val;
        if (
          typeof this.minInput != "undefined" &&
          typeof this.maxInput != "undefined" &&
          this.minInput > this.maxInput
        ) {
          this.$message({
            message: "输入的最小值不得大于最大值！",
            type: "error",
          });
          return;
        }
        this.$emit("update:maxVal", this.maxInput);
        this.$emit("change");
      },
    },
  };
  </script>
  
  <style>
  </style>


// WEBPACK FOOTER //
// src/components/fm/NumberRangeInput.vue